import React from 'react';
import { Loader, Icon, Table, Button, Header, Label } from 'semantic-ui-react';
import moment from 'moment';
import * as ExcelJS from 'exceljs/dist/exceljs.js';
import { getIdsAndTime, getDuration } from '../helper/helper';
// import { digitalInputValueFormat } from '../../../helper/digital-input-value-format';
import { REGULAR_PATH } from '../../../../env';
import SelectAssetInReport from '../SelectAssetInReport';
import { alertMessage } from '../../../helper/alert-message';
import { reportView } from '../helper/dataService';

import reportsEnv from '../reportsEnv';
import { getData, handleMultipleRequest } from '../../../helper/dataService';
import {
  XAxis,
  YAxis,
  CartesianGrid,
  ComposedChart,
  Legend,
  ResponsiveContainer,
  Area,
  Tooltip as TooltipChart,
} from 'recharts';

const { durationLimit, assetLimit } = reportsEnv.digitalInput;

class DigitalIndicator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      pdfDisableBtn: false,
      excelDisableBtn: false,
      assetsList: [],
      selectedAssets: [],
      data: [],
      startTime: moment().startOf('day'),
      endTime: moment().endOf('day'),
      digitalInput1: false,
      digitalInput2: false,
      digitalInput3: false,
      assetsWithDigitalInput: [],
      graphData: [],
    };
  }

  componentDidMount() {
    const {
      selectedAssets = [],
      startTime,
      endTime,
    } = JSON.parse(window.localStorage.getItem('reports_state'));

    this.setState({
      selectedAssets,
      startTime: moment(startTime),
      endTime: moment(endTime),
    });
  }

  getBack = () => {
    this.setState({
      data: [],
    });
  };

  downloadReport = () => {
    this.setState({
      active: true,
      pdfDisableBtn: false,
      excelDisableBtn: false,
      assetsWithDigitalInput: [],
    });
    const { ids, startTime, endTime } = getIdsAndTime(this.state);

    let promises = [];

    for (let i = 0; i < ids.length; i++) {
      let id = ids[i];
      let url = `${REGULAR_PATH}/assets/${id}/last_data?access_token=`;

      promises.push(getData(url));
    }

    let lastDataResponse = handleMultipleRequest(promises);

    Promise.all([
      lastDataResponse,
      reportView(reportsEnv.digitalInput, {
        asset_ids: ids,
        from: startTime,
        to: endTime,
      }),
    ])
      .then(([results, response]) => {
        const assetsMap = {};
        (results || []).forEach((res) => {
          if (res && res.data) {
            assetsMap[res.data.name] = res.data;
          }
        });

        const { data } = response;
        const filteredData = (data || []).filter((item) => {
          const assetName = item && item.data && item.data.asset_detail && item.data.asset_detail.name;
          const assetLastData = (assetName && assetsMap[assetName]) || Object.values(assetsMap)[0];
          if (!assetLastData) return true;

          const isS1Enabled =
            assetLastData.digital_input_sensor_1 === 'True' ||
            assetLastData.digital_input_sensor_1 === true;
          const isS2Enabled =
            assetLastData.digital_input_sensor_2 === 'True' ||
            assetLastData.digital_input_sensor_2 === true;
          const isS3Enabled =
            assetLastData.digital_input_sensor_3 === 'True' ||
            assetLastData.digital_input_sensor_3 === true;

          const name = (item.digital_indicator_name || '').trim().toLowerCase();

          const s1Names = [
            (assetLastData.digital_input_sensor_1_name || '').trim().toLowerCase(),
            'digital input 1',
            'digital indicator 1',
            'digital_input_1',
            'digital_indicator_1',
          ].filter(Boolean);

          const s2Names = [
            (assetLastData.digital_input_sensor_2_name || '').trim().toLowerCase(),
            'digital input 2',
            'digital indicator 2',
            'digital_input_2',
            'digital_indicator_2',
          ].filter(Boolean);

          const s3Names = [
            (assetLastData.digital_input_sensor_3_name || '').trim().toLowerCase(),
            'digital input 3',
            'digital indicator 3',
            'digital_input_3',
            'digital_indicator_3',
          ].filter(Boolean);

          // Prioritize enabled sensors first
          if (isS1Enabled && s1Names.includes(name)) {
            return true;
          }
          if (isS2Enabled && s2Names.includes(name)) {
            return true;
          }
          if (isS3Enabled && s3Names.includes(name)) {
            return true;
          }

          // If it matches a disabled sensor and was not matched by any enabled sensor, filter it out
          if (!isS1Enabled && s1Names.includes(name)) {
            return false;
          }
          if (!isS2Enabled && s2Names.includes(name)) {
            return false;
          }
          if (!isS3Enabled && s3Names.includes(name)) {
            return false;
          }

          if (!isS1Enabled && !isS2Enabled && !isS3Enabled) {
            return false;
          }

          return true;
        });

        this.setState({ assetDataFetched: false });

        if (filteredData.length === 0) {
          alertMessage('No data found for enabled digital indicator sensors');
        }

        this.setState({
          data: filteredData,
          active: false,
        });
      })
      .catch((error) => {
        this.setState({ active: false });
        alertMessage(`Sorry! Something went wrong`);
      });
  };

  handleDownloadExcelBtn = () => {
    const { data, startTime, endTime } = this.state;

    if (data.length > 0) {
      this.downloadExcelJS(data, startTime, endTime);
      return;
    }

    this.setState({ excelDisableBtn: true });

    const {
      ids,
      startTime: startTimeUnix,
      endTime: endTimeUnix,
    } = getIdsAndTime(this.state);

    let promises = [];

    for (let i = 0; i < ids.length; i++) {
      let id = ids[i];
      let url = `${REGULAR_PATH}/assets/${id}/last_data?access_token=`;

      promises.push(getData(url));
    }

    let lastDataResponse = handleMultipleRequest(promises);

    Promise.all([
      lastDataResponse,
      reportView(reportsEnv.digitalInput, {
        asset_ids: ids,
        from: startTimeUnix,
        to: endTimeUnix,
      }),
    ])
      .then(([results, response]) => {
        const assetsMap = {};
        (results || []).forEach((res) => {
          if (res && res.data) {
            assetsMap[res.data.name] = res.data;
          }
        });

        const { data: reportData } = response;
        const filteredData = (reportData || []).filter((item) => {
          const assetName = item && item.data && item.data.asset_detail && item.data.asset_detail.name;
          const assetLastData = (assetName && assetsMap[assetName]) || Object.values(assetsMap)[0];
          if (!assetLastData) return true;

          const isS1Enabled =
            assetLastData.digital_input_sensor_1 === 'True' ||
            assetLastData.digital_input_sensor_1 === true;
          const isS2Enabled =
            assetLastData.digital_input_sensor_2 === 'True' ||
            assetLastData.digital_input_sensor_2 === true;
          const isS3Enabled =
            assetLastData.digital_input_sensor_3 === 'True' ||
            assetLastData.digital_input_sensor_3 === true;

          const name = (item.digital_indicator_name || '').trim().toLowerCase();

          const s1Names = [
            (assetLastData.digital_input_sensor_1_name || '').trim().toLowerCase(),
            'digital input 1',
            'digital indicator 1',
            'digital_input_1',
            'digital_indicator_1',
          ].filter(Boolean);

          const s2Names = [
            (assetLastData.digital_input_sensor_2_name || '').trim().toLowerCase(),
            'digital input 2',
            'digital indicator 2',
            'digital_input_2',
            'digital_indicator_2',
          ].filter(Boolean);

          const s3Names = [
            (assetLastData.digital_input_sensor_3_name || '').trim().toLowerCase(),
            'digital input 3',
            'digital indicator 3',
            'digital_input_3',
            'digital_indicator_3',
          ].filter(Boolean);

          // Prioritize enabled sensors first
          if (isS1Enabled && s1Names.includes(name)) {
            return true;
          }
          if (isS2Enabled && s2Names.includes(name)) {
            return true;
          }
          if (isS3Enabled && s3Names.includes(name)) {
            return true;
          }

          // If it matches a disabled sensor and was not matched by any enabled sensor, filter it out
          if (!isS1Enabled && s1Names.includes(name)) {
            return false;
          }
          if (!isS2Enabled && s2Names.includes(name)) {
            return false;
          }
          if (!isS3Enabled && s3Names.includes(name)) {
            return false;
          }

          if (!isS1Enabled && !isS2Enabled && !isS3Enabled) {
            return false;
          }

          return true;
        });

        if (filteredData.length === 0) {
          alertMessage('No data found for enabled digital indicator sensors');
          this.setState({ excelDisableBtn: false });
          return;
        }

        this.downloadExcelJS(filteredData, startTime, endTime);
        this.setState({ excelDisableBtn: false });
      })
      .catch((error) => {
        this.setState({ excelDisableBtn: false });
        alertMessage(`Sorry! Something went wrong`);
      });
  };

  downloadExcelJS = (data, startTime, endTime) => {
    const workbook = new ExcelJS.Workbook();
    workbook.creator = 'Finder GPS Tracking';
    workbook.created = new Date();

    workbook.addWorksheet('Digital Indicator Report');

    const worksheet = workbook.getWorksheet('Digital Indicator Report');

    worksheet.columns = [
      { width: 10 }, // No
      { width: 35 }, // Start
      { width: 30 }, // Start Location
      { width: 35 }, // End
      { width: 30 }, // End Location
      { width: 25 }, // Time Duration
    ];

    worksheet.addRow(['Finder GPS Tracking']);
    worksheet.addRow(['Digital Indicator Report']);
    worksheet.addRow([
      `Generated on ${moment().format('MMMM Do, YYYY, hh:mm:ss A')}`,
    ]);

    worksheet.addRow();
    worksheet.addRow([
      `From: ${moment(startTime).format('dddd, MMMM Do, YYYY, hh:mm:ss A')}`,
    ]);
    worksheet.addRow([
      `Till: ${moment(endTime).format('dddd, MMMM Do, YYYY, hh:mm:ss A')}`,
    ]);

    worksheet.addRow();

    data.forEach((asset) => {
      worksheet.addRow([`Asset Name: ${asset.data.asset_detail.name}`]);
      worksheet.addRow([`Name: ${asset.digital_indicator_name}`]);
      worksheet.addRow([
        `Total On: ${asset.data.asset_detail.total_engine_on}`,
      ]);
      worksheet.addRow([
        `Total On Time: ${asset.data.asset_detail.total_ignition_on_time}`,
      ]);
      worksheet.addRow();

      const headers = [
        'No',
        'Start',
        'Start Location',
        'End',
        'End Location',
        'Time Duration',
      ];

      const headerRow = worksheet.addRow(headers);
      headerRow.eachCell((cell) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFD3D3D3' },
        };
        cell.font = {
          bold: true,
        };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
      });

      asset.data.ignition_status.forEach((item, id) => {
        const row = [
          id + 1,
          item.ignition_starts_at
            ? moment(item.ignition_starts_at.$date).format(
                'dddd, MMMM Do, YYYY, hh:mm:ss A',
              )
            : '',
          '', // Start Location placeholder
          item.ignition_stopped_at
            ? moment(item.ignition_stopped_at.$date).format(
                'dddd, MMMM Do, YYYY, hh:mm:ss A',
              )
            : '',
          '', // End Location placeholder
          item.ignition_awake,
        ];

        const newRow = worksheet.addRow(row);

        if (
          item.engine_start_loc &&
          item.engine_start_loc.coordinates &&
          item.engine_start_loc.coordinates.length === 2
        ) {
          const lat = item.engine_start_loc.coordinates[1].toFixed(6);
          const lng = item.engine_start_loc.coordinates[0].toFixed(6);
          const startCell = newRow.getCell(3);
          startCell.value = {
            text: `${lat}, ${lng}`,
            hyperlink: `https://www.google.com/maps?q=${lat},${lng}`,
            tooltip: 'View on Google Maps',
          };
          startCell.font = {
            color: { argb: 'FF0000FF' },
            underline: true,
          };
        }

        if (
          item.engine_end_loc &&
          item.engine_end_loc.coordinates &&
          item.engine_end_loc.coordinates.length === 2
        ) {
          const lat = item.engine_end_loc.coordinates[1].toFixed(6);
          const lng = item.engine_end_loc.coordinates[0].toFixed(6);
          const endCell = newRow.getCell(5);
          endCell.value = {
            text: `${lat}, ${lng}`,
            hyperlink: `https://www.google.com/maps?q=${lat},${lng}`,
            tooltip: 'View on Google Maps',
          };
          endCell.font = {
            color: { argb: 'FF0000FF' },
            underline: true,
          };
        }
      });

      worksheet.addRow();
      worksheet.addRow();
    });

    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], {
        type: 'application/octet-binary',
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Finder_Digital_Indicator_Report_${moment().format('DD-MMMM-YYYY_hh:mm A')}.xlsx`;
      a.click();
      a.remove();
    });
  };

  render() {
    const {
      selectedAssets,
      data,
      active,
      pdfDisableBtn,
      excelDisableBtn,
      startTime,
      endTime,
    } = this.state;

    const duration = getDuration(endTime, startTime);
    const assetsQuantity = selectedAssets.length;

    const isDurationLimitCross = duration > durationLimit;
    const isAssetLimitCross = assetsQuantity > assetLimit;

    if (isDurationLimitCross) {
      alertMessage(
        `You can't select this report more than ${durationLimit} days.`,
      );
    } else if (isAssetLimitCross) {
      alertMessage(
        `You can't select this report more than ${assetLimit} assets.`,
      );
    }

    const title = `Digital Indicator [A] [${durationLimit} days][${assetLimit} asset]`;
    const isValidDuration =
      duration > 0 && endTime.isSameOrAfter(startTime) && !isDurationLimitCross;
    const isValidAsset = assetsQuantity > 0 && !isAssetLimitCross;

    return (
      <div>
        {!active && data.length <= 0 && (
          <div className=' center-report'>
            <Header as='h2'>{title}</Header>

            <div style={{ margin: '20px 0' }}>
              <Label.Group size='large'>
                <Label>
                  <Icon name='car' />
                  {assetsQuantity} assets
                </Label>
                <Label>
                  <Icon name='calendar' />
                  {duration} days
                </Label>
                <Label>
                  <Icon name='play' />
                  {moment(startTime).format('dddd, MMMM Do, YYYY, hh:mm:ss A')}
                </Label>
                <Label>
                  <Icon name='stop' />
                  {moment(endTime).format('dddd, MMMM Do, YYYY, hh:mm:ss A')}
                </Label>
              </Label.Group>
            </div>

            {isValidDuration && isValidAsset && (
              <Button.Group>
                <Button
                  color='black'
                  style={{ width: '200px', fontSize: '16px' }}
                  onClick={this.downloadReport}
                  icon='eye'
                  content='VIEW HERE'
                  disabled={pdfDisableBtn || excelDisableBtn}
                />

                <Button
                  color='teal'
                  style={{ width: '200px', fontSize: '16px' }}
                  icon='file excel outline'
                  content='Download Excel'
                  onClick={this.handleDownloadExcelBtn}
                  disabled={excelDisableBtn || pdfDisableBtn}
                  loading={excelDisableBtn}
                />
              </Button.Group>
            )}
          </div>
        )}

        {!active && data.length > 0 ? (
          <div style={{ margin: '2%' }}>
            <div className='left-right'>
              <div>
                <Header as='h2'>Digital Indicator [A]</Header>
                <p>
                  Generated on: {moment().format('MMMM Do, YYYY, hh:mm:ss A')}
                </p>
              </div>
              <div>
                <Button
                  color='teal'
                  onClick={() => this.downloadExcelJS(data, startTime, endTime)}
                  style={{ marginRight: '30px' }}
                >
                  Download
                </Button>
                <Button primary onClick={this.getBack}>
                  Back
                </Button>
              </div>
            </div>

            <br />

            {data.map((item, i) => (
              <div
                key={item.digital_indicator_name}
                id={item.digital_indicator_name}
              >
                <div className='ui stackable grid'>
                  <div className='eight wide column' style={{ paddingLeft: 0 }}>
                    <div className='ui card fluid'>
                      <div className='content'>
                        <div className='header'>
                          {item.data.asset_detail.name}
                        </div>

                        <div className='description'>
                          <div>
                            <p>
                              <i className='arrow right icon' /> From:
                              {moment(startTime).format(
                                'dddd, MMMM Do, YYYY, hh:mm:ss A',
                              )}
                            </p>
                            <p>
                              <i className='arrow right icon' /> Till:{' '}
                              {moment(endTime).format(
                                'dddd, MMMM Do, YYYY, hh:mm:ss A',
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className='eight wide column'
                    style={{ paddingRight: 0 }}
                  >
                    <div className='ui card fluid'>
                      <div className='content'>
                        <h2 className='ui center aligned icon header'>
                          <i className='circular car icon' />
                        </h2>
                        <div>
                          <p
                            style={{
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            <span style={{ marginRight: 7 }}> Name:</span>
                            {item.digital_indicator_name}
                          </p>
                        </div>
                        <div>
                          <p
                            style={{
                              fontSize: 15,
                              marginTop: 5,
                              fontWeight: 600,
                            }}
                          >
                            <span style={{ marginRight: 7 }}>Total On:</span>
                            {item.data.asset_detail.total_engine_on}
                          </p>
                        </div>
                        <div>
                          <p
                            style={{
                              fontSize: 15,
                              marginTop: 5,
                              fontWeight: 600,
                            }}
                          >
                            <span style={{ marginRight: 7 }}>
                              Total On Time:
                            </span>
                            {item.data.asset_detail.total_ignition_on_time}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {item.data.ignition_status.length ? (
                  <>
                    <ResponsiveContainer height={200} width='100%'>
                      <ComposedChart
                        data={item.data.ignition_status.map((data) => ({
                          stoppedAt: data.ignition_stopped_at
                            ? moment(data.ignition_stopped_at.$date).format(
                                'DD MMM',
                              )
                            : 'No date',
                          awake: Math.ceil(data.in_seconds / 60),
                        }))}
                      >
                        <CartesianGrid stroke='#ced4da' />
                        <XAxis dataKey='stoppedAt' />
                        <YAxis />
                        <TooltipChart />
                        <Legend />
                        <Area
                          type='monotone'
                          dataKey='awake'
                          name='Awake Time (Minutes)'
                          stroke='#12b886'
                          fill='#12b886'
                          dot={false}
                          isAnimationActive={true}
                        />
                      </ComposedChart>
                    </ResponsiveContainer>
                  </>
                ) : null}

                <div>
                  <Table celled>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>No</Table.HeaderCell>
                        <Table.HeaderCell>Start</Table.HeaderCell>
                        <Table.HeaderCell>Start Location</Table.HeaderCell>
                        <Table.HeaderCell>End</Table.HeaderCell>
                        <Table.HeaderCell>End Location</Table.HeaderCell>
                        <Table.HeaderCell>Time Duration</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>

                    <Table.Body>
                      {item.data.ignition_status.map((item, id) => {
                        return (
                          <Table.Row key={id}>
                            <Table.Cell>{id + 1}</Table.Cell>
                            <Table.Cell>
                              {item.ignition_starts_at
                                ? moment(item.ignition_starts_at.$date).format(
                                    'dddd, MMMM Do, YYYY, hh:mm:ss A',
                                  )
                                : ''}
                            </Table.Cell>
                            <Table.Cell>
                              {item.engine_start_loc &&
                              item.engine_start_loc.coordinates &&
                              item.engine_start_loc.coordinates.length === 2 ? (
                                <a
                                  href={`https://www.google.com/maps?q=${item.engine_start_loc.coordinates[1]},${item.engine_start_loc.coordinates[0]}`}
                                  target='_blank'
                                  rel='noopener noreferrer'
                                >
                                  {`${item.engine_start_loc.coordinates[1].toFixed(
                                    6,
                                  )}, ${item.engine_start_loc.coordinates[0].toFixed(
                                    6,
                                  )}`}
                                  <Icon
                                    name='external alternate'
                                    style={{ marginLeft: '5px' }}
                                  />
                                </a>
                              ) : (
                                ''
                              )}
                            </Table.Cell>
                            <Table.Cell>
                              {item.ignition_stopped_at
                                ? moment(item.ignition_stopped_at.$date).format(
                                    'dddd, MMMM Do, YYYY, hh:mm:ss A',
                                  )
                                : ''}
                            </Table.Cell>
                            <Table.Cell>
                              {item.engine_end_loc &&
                              item.engine_end_loc.coordinates &&
                              item.engine_end_loc.coordinates.length === 2 ? (
                                <a
                                  href={`https://www.google.com/maps?q=${item.engine_end_loc.coordinates[1]},${item.engine_end_loc.coordinates[0]}`}
                                  target='_blank'
                                  rel='noopener noreferrer'
                                >
                                  {`${item.engine_end_loc.coordinates[1].toFixed(
                                    6,
                                  )}, ${item.engine_end_loc.coordinates[0].toFixed(
                                    6,
                                  )}`}
                                  <Icon
                                    name='external alternate'
                                    style={{ marginLeft: '5px' }}
                                  />
                                </a>
                              ) : (
                                ''
                              )}
                            </Table.Cell>
                            <Table.Cell>{item.ignition_awake}</Table.Cell>
                          </Table.Row>
                        );
                      })}
                    </Table.Body>
                  </Table>
                </div>

                <br />
              </div>
            ))}
            {data.length > 1 ? (
              <SelectAssetInReport
                assetList={data.map((d) => ({
                  asset_detail: {
                    name: d.digital_indicator_name,
                  },
                }))}
              />
            ) : null}
          </div>
        ) : (
          <Loader active={active} inline='centered'>
            Generating...
          </Loader>
        )}
      </div>
    );
  }
}

export default DigitalIndicator;
